module.exports = __webpack_public_path__ + "assets/img/17_1045_big.3f484b07.jpg";